import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppService } from "@App";
import { IConfigService } from "@Config";
import { SignatureEnvelope } from "@Models";
import { CaseHistory } from "@Models/case/case-history.interface";
import { BaseService, RoutingService } from "@Services";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable()
export class CaseHistoryService extends BaseService {
    baseUrl: string;
    publicApiBaseUrl: string;

    _documentPollingInterval: any;
    updatedData = new BehaviorSubject<any>([]);
    updatedInterview = this.updatedData.asObservable();

    constructor(
        public appService: AppService,
        public httpClient: HttpClient,
        public configService: IConfigService,
        public routingService: RoutingService
    ) {
        super(appService, configService, httpClient);

        this.baseUrl = this.appService.getAPIBaseURL();
        this.publicApiBaseUrl = this.configService.getConfiguration().publicApiUrl;
    }

    getCaseHistory(caseId: string): Observable<CaseHistory[]> {
        const clientId = this.appService.getClientId('');

        return super.getData<CaseHistory[]>(`${this.publicApiBaseUrl}client/${clientId}/case/${caseId}/caseHistory`);
    }

}